import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["input", "illustrationName", "title", "description"];
import PropTypes from 'prop-types';
import styled from 'styled-components';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import UIIllustration from 'UIComponents/image/UIIllustration';
import { isProductLogo } from '../utils/isProductLogo';
import SettingsRowWrapper from './SettingsRowWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MaxWidthSettingsRow = styled(SettingsRowWrapper).withConfig({
  displayName: "SettingsRowLayout__MaxWidthSettingsRow",
  componentId: "sc-1bcssrg-0"
})(["max-width:600px;"]);
const StyledTitle = styled.div.withConfig({
  displayName: "SettingsRowLayout__StyledTitle",
  componentId: "sc-1bcssrg-1"
})(["line-height:normal;"]);
const SettingsRowLayout = _ref => {
  let {
      input,
      illustrationName,
      title,
      description
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(MaxWidthSettingsRow, Object.assign({}, rest, {
    children: /*#__PURE__*/_jsxs(UIFlex, {
      children: [input && /*#__PURE__*/_jsx(UIBox, {
        className: "m-right-3",
        children: input
      }), illustrationName && /*#__PURE__*/_jsx(UIIllustration, {
        className: 'm-right-3' + (isProductLogo(illustrationName) ? " m-top-2" : ""),
        name: illustrationName,
        height: isProductLogo(illustrationName) ? '24px' : '60px'
      }), /*#__PURE__*/_jsxs(UIBox, {
        children: [/*#__PURE__*/_jsx(StyledTitle, {
          className: "m-bottom-1",
          children: title
        }), description]
      })]
    })
  }));
};
SettingsRowLayout.propTypes = {
  /**
   * UICheckbox or UIToggle to render for settings state.
   */
  input: PropTypes.node,
  /**
   * Illustration or logo name to render.
   */
  illustrationName: PropTypes.string,
  /**
   * Text for the setting title.
   */
  title: PropTypes.node.isRequired,
  /**
   * Description for this setting.
   */
  description: PropTypes.node
};
export default SettingsRowLayout;